import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const snackbarRecipe = sva({
    slots: ['root', 'message', 'action', 'exit'],
    base: {
        root: {
            padding: '[16px 16px 16px 24px]',
            display: 'flex',
            width: '[100%]',
            alignItems: 'center',
            justifyContent: 'space-between',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            animation: 'fadeIn 250ms ease-out forwards',
        },
        message: {},
        action: {
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '[8px]',
        },
        exit: {
            background: '[none]',
            cursor: 'pointer',
            border: 'none',
            padding: '[5px]',
        },
    },
    variants: {
        variant: {
            default: {
                root: {
                    backgroundColor: 'extra-dark-teal.100',
                    color: 'text.reversed',
                    _dark: {
                        backgroundColor: 'cream.100',
                        color: 'text',
                    },
                },
                message: {
                    color: 'cream.100',
                    _dark: {
                        color: 'text.reversed',
                    },
                },
                action: {
                    color: 'links.reversed',
                },
                exit: {
                    color: 'text',
                    _hover: {
                        backgroundColor: 'background.opacity-10',
                    },
                },
            },
            confirmation: {
                root: {
                    backgroundColor: 'elements.confirmation.fill',
                    color: 'elements.confirmation.contrast-reversed',
                },
                action: {},
                exit: {
                    _hover: {
                        backgroundColor: 'elements.confirmation.contrast',
                    },
                },
            },
            error: {
                root: {
                    backgroundColor: 'elements.error.fill',
                    color: 'elements.error.contrast',
                },
                action: {},
                exit: {
                    _hover: {
                        backgroundColor: 'elements.error.contrast',
                    },
                },
            },
        },
        shape: {
            rounded: {
                root: {
                    borderRadius: 'full',
                },
            },
            square: {
                root: {
                    borderRadius: 'sm',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'default',
        shape: 'square',
    },
});

type SnackbarRecipeProps = RecipeVariantProps<typeof snackbarRecipe>;

export { snackbarRecipe, snackbarRecipe as default };
export type { SnackbarRecipeProps };
